import api from '@/helpers/api';

const API_READ = `/api/marketing/`;
const API_UPDATE = API_READ;
const API_CREATE = API_READ;
const API_DELETE = API_READ;
const API_SYNC = `${API_READ}sync`;

export default {
  namespaced: true,
  state: {
    status: '',
    marketings: [],
    currentMarketing: null,
    errMessage: '',
    meta: {
      page: 1,
      limit: 10,
      total: 1,
    },
    filter: {
      time_scale: null,
      date_from: null,
      date_to: null,
    },
    search: {},
  },
  mutations: {
    request(state) {
      state.status = 'loading';
    },
    success(state) {
      state.status = 'success';
    },
    error(state) {
      state.status = 'error';
    },
    read(state, { marketings, meta }) {
      state.marketings = [...marketings];
      state.meta = { ...meta };
    },
    read_single_success(state, { marketing }) {
      state.currentMarketing = marketing;
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta };
    },
    add_filter(state, { filter }) {
      state.filter = { ...filter };
    },
    set_time_filter(state, { time_scale, date_from, date_to }) {
      state.filter = { ...state.filter, time_scale, date_from, date_to };
    },
    clear_time_filter(state) {
      state.filter = { time_scale: null, date_from: null, date_to: null };
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta, search, filter } = state;

      const cleanFilter = {};
      if (filter) {
        Object.entries(filter).forEach(([key, val]) => {
          if (val !== null && val !== undefined && val !== '') {
            cleanFilter[key] = val;
          }
        });
      }

      return new Promise((resolve, reject) => {
        api
          .request('get', API_READ, { meta, search, filter: Object.keys(cleanFilter).length ? cleanFilter : undefined })
          .then((result) => {
            commit('read', {
              marketings: result.data.data,
              meta: result.data.meta,
            });
            commit('success');
            resolve(result);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    readAssignedToMe({ commit }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('get', `${API_READ}assigned-to-me`)
          .then((result) => {
            commit('read_single_success', { marketing: result.data.data });
            commit('success');
            resolve(result);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    readById({ commit }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('get', `${API_READ}${id}`)
          .then((result) => {
            commit('read_single_success', { marketing: result.data.data });
            commit('success');
            resolve(result);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    delete({ commit, dispatch }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('delete', `${API_DELETE}${id}`)
          .then((response) => {
            dispatch('read');
            commit('success');
            resolve(response.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err.response?.data || err);
          });
      });
    },
    update({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('put', `${API_UPDATE}${data.id}`, {}, data)
          .then((request) => {
            commit('success');
            resolve(request);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    create({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', API_CREATE, {}, data)
          .then((request) => {
            commit('success');
            resolve(request);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    sync({ commit }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', API_SYNC)
          .then((request) => {
            commit('success');
            resolve(request);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
  },
  getters: {
    marketings: (state) => state.marketings,
    currentMarketing: (state) => state.currentMarketing,
  },
};
